<div class="background-bar">
    <div class="progress progress-bar-target" [ngClass]="betStateClassName()">
        <span class="target-indicator"></span>
        <span class="target-value">{{ targetStatValue() }}</span>
    </div>
    <div class="progress" [style.width]="progressBarWidth()" [ngClass]="betStateClassName()">
        <span class="slider-handle"
            ><span class="current-stats">{{ currentStatValue() }}</span></span
        >
    </div>
</div>
